(function () {
  var FORM_ID = 1145638;
  var VARIANT_ID = 45512171880624;
  var SUBMIT_URL = 'https://forms.shopifyapps.com/api/v2/form_submission';
  var SITEKEY = '2e7f6342-57df-422a-8431-ddd86df296bc';
  var hcaptchaReady = null;

  function shopDomain() {
    try { return (window.Shopify && Shopify.shop) || 'cptcexam.myshopify.com'; } catch (e) { return 'cptcexam.myshopify.com'; }
  }

  function loadHcaptcha() {
    if (window.hcaptcha && typeof window.hcaptcha.execute === 'function') {
      return Promise.resolve(window.hcaptcha);
    }
    if (hcaptchaReady) return hcaptchaReady;
    hcaptchaReady = new Promise(function (resolve, reject) {
      var existing = document.getElementById('cptc-hcaptcha-api');
      if (existing) {
        existing.addEventListener('load', function () { resolve(window.hcaptcha); });
        existing.addEventListener('error', reject);
        return;
      }
      window._cptcHcaptchaOnLoad = function () { resolve(window.hcaptcha); };
      var s = document.createElement('script');
      s.id = 'cptc-hcaptcha-api';
      s.src = 'https://js.hcaptcha.com/1/api.js?onload=_cptcHcaptchaOnLoad&render=explicit';
      s.async = true;
      s.defer = true;
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return hcaptchaReady;
  }

  function ensureWidget(host) {
    var node = host.querySelector('[data-cptc-hcaptcha]');
    if (!node) {
      node = document.createElement('div');
      node.setAttribute('data-cptc-hcaptcha', '');
      node.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden;';
      host.appendChild(node);
    }
    return loadHcaptcha().then(function (hc) {
      if (node.getAttribute('data-widget-id')) return Number(node.getAttribute('data-widget-id'));
      var id = hc.render(node, { sitekey: SITEKEY, size: 'invisible' });
      node.setAttribute('data-widget-id', String(id));
      return id;
    });
  }

  function executeCaptcha(host) {
    return ensureWidget(host).then(function (widgetId) {
      return new Promise(function (resolve, reject) {
        try {
          window.hcaptcha.execute(widgetId, { async: true }).then(function (result) {
            resolve((result && result.response) || result || '');
          }).catch(reject);
        } catch (err) {
          try {
            window.hcaptcha.execute(widgetId);
            var tries = 0;
            var timer = setInterval(function () {
              tries += 1;
              var token = window.hcaptcha.getResponse(widgetId);
              if (token || tries > 40) {
                clearInterval(timer);
                if (token) resolve(token); else reject(new Error('Captcha failed'));
              }
            }, 100);
          } catch (e2) { reject(e2); }
        }
      });
    });
  }

  function showThanks(root) {
    root.classList.add('is-thanks');
    var thanks = root.querySelector('[data-cptc-lead-thanks]');
    if (thanks) {
      thanks.hidden = false;
      thanks.classList.add('is-visible');
      try { thanks.focus({ preventScroll: true }); } catch (e) {}
      try { thanks.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    }
    var form = root.querySelector('[data-cptc-lead-form]');
    if (form) form.hidden = true;
  }

  function setError(root, msg) {
    var el = root.querySelector('[data-cptc-lead-error]');
    if (!el) return;
    if (!msg) { el.hidden = true; el.textContent = ''; return; }
    el.hidden = false;
    el.textContent = msg;
  }

  function startFreeCheckout(root) {
    var variantId = Number(root.getAttribute('data-variant-id') || VARIANT_ID);
    var status = root.querySelector('[data-cptc-lead-delivery]');
    if (status) {
      status.hidden = false;
      status.textContent = 'Preparing your free download checkout…';
    }
    var hasPaidItems = false;
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { if (!res.ok) throw new Error('cart read failed'); return res.json(); })
      .then(function (cart) {
        hasPaidItems = cart.items.some(function (item) { return item.final_line_price > 0; });
        if (cart.items.some(function (item) { return Number(item.variant_id) === variantId; })) return { ok: true };
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
      })
      .then(function (res) {
        if (!res || !res.ok) throw new Error('cart add failed');
        window.location.href = hasPaidItems ? '/cart' : '/checkout';
      })
      .catch(function () {
        if (status) {
          status.textContent = 'Almost there — continue to free checkout to get your download.';
        }
        var fallback = root.querySelector('[data-cptc-lead-checkout]');
        if (fallback) fallback.hidden = false;
      });
  }

  function bind(root) {
    if (!root || root.getAttribute('data-cptc-lead-bound')) return;
    root.setAttribute('data-cptc-lead-bound', '1');
    var form = root.querySelector('[data-cptc-lead-form]');
    if (!form) return;
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      setError(root, '');
      var btn = form.querySelector('[type="submit"]');
      var first = (form.querySelector('[name="first_name"]') || {}).value || '';
      var email = (form.querySelector('[name="email"]') || {}).value || '';
      first = String(first).trim();
      email = String(email).trim();
      if (!first) { setError(root, 'First name is required'); return; }
      if (!email) { setError(root, 'Email is required'); return; }
      var emailInput = form.querySelector('[name="email"]');
      if (emailInput && !emailInput.checkValidity()) { setError(root, 'Please enter a valid email address.'); emailInput.focus(); return; }
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      executeCaptcha(root).then(function (token) {
        function readCookie(name) {
          var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\/+^])/g, '\$1') + '=([^;]*)'));
          return m ? decodeURIComponent(m[1]) : '';
        }
        var payload = {
          shopify_domain: shopDomain(),
          form_instance_id: FORM_ID,
          h_captcha_response: token || '',
          first_name: first,
          email: email,
          customer_consented_to_email_marketing: true,
          customer_consented_to_sms_marketing: false,
          shopify_y_token: readCookie('_shopify_y'),
          shopify_s_token: readCookie('_shopify_s'),
          shopify_y_domain: (location && location.hostname) || ''
        };
        try {
          var privacy = window.Shopify && Shopify.customerPrivacy;
          if (privacy) {
            payload.privacy_analytics_allowed = privacy.analyticsProcessingAllowed();
            payload.privacy_marketing_allowed = privacy.marketingAllowed();
            payload.privacy_sale_of_data_allowed = privacy.saleOfDataAllowed();
            payload.privacy_preferences_allowed = privacy.preferencesProcessingAllowed();
          }
        } catch (e) {}
        return fetch(SUBMIT_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
          credentials: 'omit',
          mode: 'cors'
        }).then(function (res) {
          return res.text().then(function (text) {
            var data = null;
            try { data = text ? JSON.parse(text) : null; } catch (e) {}
            return { ok: res.ok, status: res.status, data: data, text: text };
          });
        });
      }).then(function (result) {
        if (result.ok) {
          try {
            if (window.Shopify && window.Shopify.analytics) {
              window.Shopify.analytics.publish('cptc_email_signup', { placement: root.id || 'lead-magnet' });
            }
          } catch (e) {}
          showThanks(root);
          return startFreeCheckout(root);
        }
        var msg = 'Something went wrong. Please try again.';
        if (result.data) {
          if (typeof result.data.error === 'string') msg = result.data.error;
          if (result.data.errors) {
            if (typeof result.data.errors === 'string') msg = result.data.errors;
            else if (result.data.errors.message) msg = result.data.errors.message;
          }
          if (typeof result.data.message === 'string') msg = result.data.message;
        }
        setError(root, msg);
      }).catch(function () {
        setError(root, 'Something went wrong. Please try again.');
      }).finally(function () {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-cptc-forms-lead]').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
